import API from './api.js'

export default {
    async getAnalyzes() {
        try {
            let response = await API.HTTPS.get('/analyses')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getPriceByType(type) {
        try {
            let response = await API.HTTPS.get('/analyses/type/' + type + '/price')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getPrices() {
        try {
            let response = await API.HTTPS.get('/analyses/price')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getPrice(id) {
        try {
            let response = await API.HTTPS.get('/analyses/' + id + '/price')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}